import CheckShield from '../src/CheckShield/index';
export default CheckShield;
